//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
export const MockActions = [
  {
    stage: "onQRScanned",
    actions: [
      {
        page: {
          title: "Please keep this window open",
          subtitle: "You can now follow the instructions on your phone",
          icon: {
            value: "PhoneOutline",
          },
          mixpanelEvent: null,
          useLoader: true,
          loader: "CircleSpinner",
          id: "web-comp.push-to-web.0.TutorialWithLoaderPage",
          type: "TutorialWithLoaderPage",
          webStage: null,
          mixpanelStep: null,
          headerTitle: null,
          scanner_rect_width: null,
          scanner_rect_height: null,
          hamburgerIconColor: "black",
        },
        sound: null,
        transitionType: "fadein",
        finishPreviousPageRequestUrl: null,
        mixpanelEvent: null,
        successMixpanelEvent: null,
        analyticsEvent: null,
        type: "GoToNextPageAction",
        id: "web-comp.push-to-web.0.GoToNextPageAction",
      },
      {
        id: "web-comp.push-to-web.1.CallCallbackAction",
        type: "CallCallbackAction",
        callbackType: "analytics",
        event: {
          title: "onQRScanned",
          description: "QR scanned successfully",
        },
        isEndOfFlow: false,
      },
    ],
  },
  {
    stage: "onScreenCalibrationTutorialFinished",
    actions: [
      {
        page: {
          data: {
            green: "#00FF00",
            overall_height: 436.1039999999999,
            overall_width: 695.3039999999999,
            marker_thickness_px: 9.719999999999999,
            marker_radius_px: 13.931999999999997,
            marker_outer_radius_px: 23.651999999999994,
            marker2marker_width_px: 323.99999999999994,
            marker2marker_height_px: 388.79999999999995,
            showBoundaries: true,
          },
          mixpanelEvent: {
            id: "web-comp.push-to-web.0.MixpanelEvent",
            type: "MixpanelEvent",
            title: "pv web calibration",
            eventType: "pv",
            innerTitle: "Calibration",
            category: "Good",
          },
          id: "web-comp.push-to-web.0.MarkersAndTargetsPage",
          type: "MarkersAndTargetsPage",
          webStage: null,
          mixpanelStep: null,
          headerTitle: null,
          scanner_rect_width: null,
          scanner_rect_height: null,
          hamburgerIconColor: "black",
        },
        sound: null,
        transitionType: "fadein",
        finishPreviousPageRequestUrl: null,
        mixpanelEvent: null,
        successMixpanelEvent: null,
        analyticsEvent: null,
        type: "GoToNextPageAction",
        id: "web-comp.push-to-web.0.GoToNextPageAction",
      },
      {
        id: "web-comp.push-to-web.1.CallCallbackAction",
        type: "CallCallbackAction",
        callbackType: "analytics",
        event: {
          title: "onScreenCalibrationTutorialFinished",
          description: "Screen calibration tutorial is finished",
        },
        isEndOfFlow: false,
      },
    ],
  },
  {
    stage: "onScreenCalibrated",
    actions: [
      {
        page: {
          title: "Please keep this window open",
          subtitle: "You can now follow the instructions on your phone",
          icon: {
            value: "PhoneOutline",
          },
          mixpanelEvent: null,
          useLoader: true,
          loader: "CircleSpinner",
          id: "web-comp.push-to-web.0.TutorialWithLoaderPage",
          type: "TutorialWithLoaderPage",
          webStage: null,
          mixpanelStep: null,
          headerTitle: null,
          scanner_rect_width: null,
          scanner_rect_height: null,
          hamburgerIconColor: "black",
        },
        sound: null,
        transitionType: "fadein",
        finishPreviousPageRequestUrl: null,
        mixpanelEvent: null,
        successMixpanelEvent: null,
        analyticsEvent: null,
        type: "GoToNextPageAction",
        id: "web-comp.push-to-web.0.GoToNextPageAction",
      },
    ],
  },
  {
    stage: "onAnalyzeTutorialFinished",
    actions: [
      {
        page: {
          data: {
            green: "#00FF00",
            overall_height: 681.4115710104147,
            overall_width: 1086.411018862073,
            marker_thickness_px: 15.18747929443718,
            marker_radius_px: 21.768720322026624,
            marker_outer_radius_px: 36.956199616463806,
            marker2marker_width_px: 506.24930981457265,
            marker2marker_height_px: 607.4991717774872,
            showBoundaries: false,
            showHighResolution: false,
            showMultifocalLines: false,
            italicTargetsOn: true,
            showDashes: false,
            focus_area: {
              thickness: 4.878218349373223,
              length: 24.391091746866113,
              position: {
                left: {
                  x: 468.92354820194424,
                  y: 44.347439539756564,
                },
                right: {
                  x: 593.0963789132626,
                  y: 44.347439539756564,
                },
                width: 24.391091746866113,
                height: 24.391091746866113,
              },
            },
            targets: {
              left: {
                x: 229.33093734600146,
                y: 340.70578550520736,
                targets: [
                  {
                    radius: 79.7342662957952,
                    radius_color: "#00FF00",
                    outer_radius: 94.92174559023238,
                    outer_radius_color: "white",
                    thickness: 15.18747929443718,
                  },
                  {
                    radius: 53.15617753053013,
                    radius_color: "white",
                    outer_radius: 68.34365682496731,
                    outer_radius_color: "#00FF00",
                    thickness: 15.18747929443718,
                  },
                  {
                    radius: 26.578088765265065,
                    radius_color: "#F00000",
                    outer_radius: 41.76556805970225,
                    outer_radius_color: "white",
                    thickness: 15.18747929443718,
                  },
                ],
              },
              right: {
                x: 857.0800815160715,
                y: 340.70578550520736,
                targets: [
                  {
                    radius: 79.7342662957952,
                    radius_color: "#00FF00",
                    outer_radius: 94.92174559023238,
                    outer_radius_color: "white",
                    thickness: 15.18747929443718,
                  },
                  {
                    radius: 53.15617753053013,
                    radius_color: "white",
                    outer_radius: 68.34365682496731,
                    outer_radius_color: "#00FF00",
                    thickness: 15.18747929443718,
                  },
                  {
                    radius: 26.578088765265065,
                    radius_color: "#F00000",
                    outer_radius: 41.76556805970225,
                    outer_radius_color: "white",
                    thickness: 15.18747929443718,
                  },
                ],
              },
              show_pupils: false,
              targets_boundaries: {
                left: {
                  x: 229.33093734600146,
                  y: 340.70578550520736,
                  radious: 104.41392014925562,
                },
                right: {
                  x: 857.0800815160715,
                  y: 340.70578550520736,
                  radious: 104.41392014925562,
                },
                opacity: 1,
              },
            },
            lines: {
              left: {
                x1: 229.33093734600146,
                x2: 276.79181014111765,
                x3: 181.87006455088527,
                yi: 435.62753109543974,
                yf: 739.3771169841833,
              },
              right: {
                x1: 857.0800815160715,
                x2: 904.5409543111876,
                x3: 809.6192087209553,
                yi: 435.62753109543974,
                yf: 739.3771169841833,
              },
              lines_width_px: 2.531246549072863,
            },
          },
          mixpanelEvent: {
            id: "web-comp.push-to-web.0.MixpanelEvent",
            type: "MixpanelEvent",
            title: null,
            eventType: "pv",
            innerTitle: "analyze",
            category: "Good",
          },
          id: "web-comp.push-to-web.0.MarkersAndTargetsPage",
          type: "MarkersAndTargetsPage",
          webStage: null,
          mixpanelStep: null,
          headerTitle: null,
          scanner_rect_width: null,
          scanner_rect_height: null,
          hamburgerIconColor: "black",
        },
        sound: null,
        transitionType: "fadein",
        finishPreviousPageRequestUrl: null,
        mixpanelEvent: null,
        successMixpanelEvent: null,
        analyticsEvent: null,
        type: "GoToNextPageAction",
        id: "web-comp.push-to-web.0.GoToNextPageAction",
      },
      {
        id: "web-comp.push-to-web.1.CallCallbackAction",
        type: "CallCallbackAction",
        callbackType: "analytics",
        event: {
          title: "onGoLensesTutorialFinished",
          description: "Verify tutorial is finished",
        },
        isEndOfFlow: false,
      },
    ],
  },
  {
    stage: "onTargetsModified",
    actions: [
      {
        uuid: "4a58fcd2-6a40-4897-8b36-5524b0a2e2e4",
        targets_data: {
          green: "#00FF00",
          overall_height: 681.4115710104147,
          overall_width: 1086.411018862073,
          marker_thickness_px: 15.18747929443718,
          marker_radius_px: 21.768720322026624,
          marker_outer_radius_px: 36.956199616463806,
          marker2marker_width_px: 506.24930981457265,
          marker2marker_height_px: 607.4991717774872,
          showBoundaries: false,
          showHighResolution: false,
          showMultifocalLines: false,
          italicTargetsOn: true,
          showDashes: false,
          focus_area: {
            thickness: 4.878218349373223,
            length: 24.391091746866113,
            position: {
              left: {
                x: 468.92354820194424,
                y: 44.347439539756564,
              },
              right: {
                x: 593.0963789132626,
                y: 44.347439539756564,
              },
              width: 24.391091746866113,
              height: 24.391091746866113,
            },
          },
          targets: {
            left: {
              x: 229.33093734600146,
              y: 340.70578550520736,
              targets: [
                {
                  radius: 156.9372860425175,
                  radius_color: "#00FF00",
                  outer_radius: 209.24971472335667,
                  outer_radius_color: "white",
                  thickness: 52.31242868083917,
                },
                {
                  radius: 104.62485736167834,
                  radius_color: "white",
                  outer_radius: 156.9372860425175,
                  outer_radius_color: "#00FF00",
                  thickness: 52.31242868083917,
                },
                {
                  radius: 52.31242868083917,
                  radius_color: "#F00000",
                  outer_radius: 104.62485736167834,
                  outer_radius_color: "white",
                  thickness: 52.31242868083917,
                },
              ],
            },
            right: {
              x: 857.0800815160715,
              y: 340.70578550520736,
              targets: [
                {
                  radius: 155.9500998883791,
                  radius_color: "#00FF00",
                  outer_radius: 207.93346651783878,
                  outer_radius_color: "white",
                  thickness: 51.983366629459695,
                },
                {
                  radius: 103.96673325891939,
                  radius_color: "white",
                  outer_radius: 155.9500998883791,
                  outer_radius_color: "#00FF00",
                  thickness: 51.983366629459695,
                },
                {
                  radius: 51.983366629459695,
                  radius_color: "#F00000",
                  outer_radius: 103.96673325891939,
                  outer_radius_color: "white",
                  thickness: 51.983366629459695,
                },
              ],
            },
            show_pupils: false,
            targets_boundaries: {
              left: {
                x: 229.33093734600146,
                y: 340.70578550520736,
                radious: 230.17468619569237,
              },
              right: {
                x: 857.0800815160715,
                y: 340.70578550520736,
                radious: 228.7268131696227,
              },
              opacity: 1,
            },
          },
          lines: {
            left: {
              x1: 229.33093734600146,
              x2: 333.9557947076798,
              x3: 124.70607998432313,
              yi: 549.955500228564,
              yf: 853.7050861173076,
            },
            right: {
              x1: 857.0800815160715,
              x2: 961.0468147749908,
              x3: 753.1133482571521,
              yi: 548.6392520230462,
              yf: 852.3888379117898,
            },
            lines_width_px: 2.531246549072863,
          },
        },
        mixpanelEvent: {
          id: "web-comp.push-to-web.0.MixpanelEvent",
          type: "MixpanelEvent",
          title: "pv web analyze targets resize",
          eventType: "pv",
          innerTitle: "analyze",
          category: "Good",
        },
        actionType: "ServerAction",
        type: "ModifyClientTargetsAction",
        id: "web-comp.push-to-web.0.ModifyClientTargetsAction",
      },
    ],
  },
  {
    stage: "onResultsReady",
    actions: [
      {
        id: "web-comp.push-to-web.0.CallCallbackAction",
        type: "CallCallbackAction",
        callbackType: "results",
        event: null,
        isEndOfFlow: false,
      },
      {
        page: {
          title: "Please keep this window open",
          subtitle: "You can now follow the instructions on your phone",
          icon: {
            value: "PhoneOutline",
          },
          mixpanelEvent: null,
          useLoader: true,
          loader: "CircleSpinner",
          id: "web-comp.push-to-web.1.TutorialWithLoaderPage",
          type: "TutorialWithLoaderPage",
          webStage: null,
          mixpanelStep: null,
          headerTitle: null,
          scanner_rect_width: null,
          scanner_rect_height: null,
          hamburgerIconColor: "black",
        },
        sound: null,
        transitionType: "fadein",
        finishPreviousPageRequestUrl: null,
        mixpanelEvent: null,
        successMixpanelEvent: null,
        analyticsEvent: null,
        type: "GoToNextPageAction",
        id: "web-comp.push-to-web.1.GoToNextPageAction",
      },
    ],
    result: {
      anonymous_user_id: "C55245C9-F230-4D69-B80D-FF0DF8E49A9F",
      campaignId: "hub__go_lenses",
      session_id: "806341C2-B794-465C-AC54-A4C50ADC4863",
      tilt_session_id: "6A611ED8-FF0C-44E1-97E7-CD90634DDD33",
      phone_model: "iPhone13,3",
      software_version: "5.25.0 (4594)",
      error_type: "NONE",
      l_axis: "-",
      l_cyl: "-",
      l_sph: "-4.50",
      r_axis: "-",
      r_cyl: "-",
      r_sph: "-3.25",
      multitilt_attempts: "1",
      frame_size: null,
      is_pd_oor: false,
      is_pd_session_timedout: false,
      pd: "",
    },
  },
  {
    stage: "onPdVerifyTutorialFinished",
    actions: [
      {
        id: "web-comp.push-to-web.0.CallCallbackAction",
        type: "CallCallbackAction",
        callbackType: "analytics",
        event: {
          title: "onPdTutorialFinished",
          description: "PD tutorial is finished",
        },
        isEndOfFlow: false,
      },
    ],
  },
  {
    stage: "onPdReady",
    actions: [
      {
        id: "web-comp.push-to-web.0.CallCallbackAction",
        type: "CallCallbackAction",
        callbackType: "results",
        event: null,
        isEndOfFlow: true,
      },
    ],
    result: {
      anonymous_user_id: "C55245C9-F230-4D69-B80D-FF0DF8E49A9F",
      campaignId: "hub__go_lenses",
      session_id: "806341C2-B794-465C-AC54-A4C50ADC4863",
      tilt_session_id: "6A611ED8-FF0C-44E1-97E7-CD90634DDD33",
      phone_model: "iPhone13,3",
      software_version: "5.25.0 (4594)",
      error_type: "NONE",
      l_axis: "-",
      l_cyl: "-",
      l_sph: "-4.50",
      r_axis: "-",
      r_cyl: "-",
      r_sph: "-3.25",
      multitilt_attempts: "1",
      frame_size: {
        lens_width: 51,
        bridge_width: 17,
        frame_width: 133,
      },
      is_pd_oor: false,
      is_pd_session_timedout: false,
      pd: "63.0",
    },
  },
];
